import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolbarMenu from './ToolbarMenu';
import ToolButton from './ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';

// Stylus toolbar sub-menu for choosing a pen stylus.
const PenMenu: React.FC = () => {
  const controller = useController(WhiteboardController);

  return (
    <ToolbarMenu columns={1}>
      {controller.penStyluses.map((stylus, i) => (
        <ToolButton
          key={i}
          onMouseDown={event => {
            controller.actionSetPenStylus(stylus);
            controller.actionSetStylusMenu(null);
            event.stopPropagation();
          }}
        >
          {stylus.renderIcon()}
        </ToolButton>
      ))}
    </ToolbarMenu>
  );
};

export default ApplicationView(PenMenu);
